import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

export const task: Task = {
  id: "44d571f0-0b82-4dd6-abad-e2b8057f3de4",
  solutionType: "text-or-number",
  type: "fillTheGap",
  options: {
    type: "number",
    prefixText: "Input the value of the <b>resonance frequency</b> (rounded to the first decimal place):",
    unit: "Hz",
  },
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "text-or-number",
  data: 21.5,
};
